module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=424px height=426px viewBox=\"0 0 424 426\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon points=\"318.291414 184.648232 172.534055 38.890873 211.424928 0 423.556962 212.132034 422.849855 212.839141 423.556962 213.546248 211.424928 425.678282 172.534055 386.787409 319.673232 239.648232 0 239.648232 0 184.648232 318.291414 184.648232\"></polygon> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/arrow-right.svg
// module id = 274
// module chunks = 0